import { render } from "./Auth.vue?vue&type=template&id=fa7dc41c&scoped=true&ts=true"
import script from "./Auth.vue?vue&type=script&lang=ts"
export * from "./Auth.vue?vue&type=script&lang=ts"

import "./Auth.vue?vue&type=style&index=0&id=fa7dc41c&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa7dc41c"]])

export default __exports__